import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export type DatePreset = 'custom' | 'last7days' | 'last30days' | 'last90days' | 'last6months';

export interface DateRange {
  from: Date | null;
  to: Date | null;
}

export const PRESET_LABELS: Record<DatePreset, string> = {
  custom: 'Custom',
  last7days: 'Last 7 days',
  last30days: 'Last 30 days',
  last90days: 'Last 90 days',
  last6months: 'Last 6 months',
};

const PRESET_STARTS: Record<Exclude<DatePreset, 'custom'>, (now: dayjs.Dayjs) => dayjs.Dayjs> = {
  last7days: (now) => now.subtract(7, 'day'),
  last30days: (now) => now.subtract(30, 'day'),
  last90days: (now) => now.subtract(90, 'day'),
  last6months: (now) => now.subtract(6, 'month'),
};

export function resolvePreset(preset: Exclude<DatePreset, 'custom'>, now: Date): DateRange {
  const end = dayjs.utc(now);
  const start = PRESET_STARTS[preset](end);
  return {
    from: start.startOf('day').toDate(),
    to: end.endOf('day').toDate(),
  };
}
